module.exports = __webpack_public_path__ + "static/favicon-512-dcd79317515ba6160e09f390f13e94d9.png";